const MAIN_PATH = '/business/users';

export const ROUTES = {
  BUSINESS_USERS: MAIN_PATH,
  BUSINESS_USER_ROLE_UPDATE: `${MAIN_PATH}/:userId/edit`,
};
